import React, { useState } from 'react';
import { 
    Container, Typography, Card, CardActions, CardContent, 
    CardMedia, Button, Dialog, DialogActions, DialogContent, DialogTitle, Fab, Box
} from '@mui/material';
import { collection, getDocs, updateDoc, doc, setDoc, query, where } from 'firebase/firestore';
import moment from 'moment';
import { firestore } from './firebase.config';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import './home.css';

const Home = () => {
    const [events, setEvents] = useState([]);
    const [bookings, setBookings] = useState({});
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [openEventDialog, setOpenEventDialog] = useState(false);
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
    const [confirmationAction, setConfirmationAction] = useState(null);
    const [hoverText, setHoverText] = useState("");

    const handleCloseEventDialog = () => {
        setOpenEventDialog(false);
        setSelectedEvent(null);
    };

    return (
        <Box
            className="home-background"
            sx={{
                position: 'absolute',
                top: 64,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px',
                boxSizing: 'border-box',
                overflow: 'hidden'
            }}
        >
            <Typography 
                variant="h2" 
                component="h1" 
                align="center"
                className="welcome-text"
                sx={{ 
                    fontWeight: 'bold',
                    mb: 3,
                    fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4.5rem' }
                }}
            >
                Welcome to OV Retail
            </Typography>
            
            <Typography 
                variant="h5" 
                component="h2" 
                align="center"
                className="welcome-text"
                sx={{ 
                    maxWidth: '800px',
                    fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' }
                }}
            >
                Your comprehensive solution for retail management and business operations
            </Typography>

            {openEventDialog && (
                <Dialog open={openEventDialog} onClose={handleCloseEventDialog}>
                    {/* Dialog content here */}
                </Dialog>
            )}
            
            {openConfirmationDialog && (
                <Dialog open={openConfirmationDialog}>
                    {/* Confirmation dialog content here */}
                </Dialog>
            )}
        </Box>
    );
};

export default Home;